import { FC } from "react";
import { Form } from "formik";
import { NavLink } from "react-router-dom";
import { Box, Button, Card, Container } from "@mui/material";

import LoginInput from "../common/LoginInput";
import LoginHeading from "../common/LoginHeading";
import LoginMedantaLogo from "../common/LoginLogo";
import LoginFooter from "../../../common/Footer/LoginFooter";

import {RoutingList} from "../../../../constants";
import styles from "../Login.module.scss";

const LoginForm: FC = () => {

    return (
        <Form>
            <Box className={styles.formSpace}>
                <Container>
                    <LoginMedantaLogo />
                    <Box className={styles.loginBox}>
                        <div className={styles.loginWrap}>
                            <Card className={styles.loginCard} variant="outlined">
                                <div className={styles.cardBody}>
                                    <LoginHeading title="Sign In to EHC" />

                                    <LoginInput label="Email" name="email" type="email" placeholder="Email" />

                                    <LoginInput label="Password" name="password" type="password" placeholder="Password" />
                                        {/* <NavLink to={RoutingList.login.forgot_password.path} color={"error"}
                                            className="pd-x-0 pd-y-0 text-decoration-none text-danger font-size-sm">
                                            Forgot Password?
                                        </NavLink> */}
                                    {/* </LoginInput> */}


                                    <div className={`d-flex justify-content-center ${styles.loginFooter}`}>
                                        <Button variant={"contained"} color={"error"} type="submit">
                                            Sign In
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Box>
                    <LoginFooter />
                </Container>
            </Box>
        </Form>
    )
}

export default LoginForm